import { Mail } from 'lucide-react';
import { trackSocialClick, trackNewsletterClick, CLICK_SOURCES } from '../utils/analytics';
import { newsletterUrl } from './NewsletterCta';

const TIKTOK_URL = "https://www.tiktok.com/@ditsc.com";
const FACEBOOK_URL = "https://www.facebook.com/digginginthesalescrates/";
// Shows on every page, so it carries its own utm_medium (footer).
const NEWSLETTER_URL = newsletterUrl("footer");

export default function FollowUs() {
  return (
    // minHeight reserves space for this section before it renders/hydrates so the
    // footer below it doesn't jump when this mounts (CLS fix). Set inline rather
    // than relying only on CSS so it's guaranteed regardless of stylesheet load
    // order. ~72px covers the single-row layout (label + two pills); on narrow
    // viewports where flex-wrap pushes the pills to a second row this undershoots
    // slightly, which is a much smaller shift than reserving no height at all.
    <div className="follow-us-section" style={{ minHeight: 72 }}>
      <span className="follow-us-label">follow ditsc</span>
      <div className="follow-us-links">
        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="follow-pill follow-pill--tiktok"
          aria-label="Follow DITSC on TikTok"
          onClick={() => trackSocialClick('tiktok', 'follow_us_section')}
        >
          <TikTokIcon />
          @ditsc.com
        </a>
        <a
          href={FACEBOOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="follow-pill follow-pill--facebook"
          aria-label="Follow DITSC on Facebook"
          onClick={() => trackSocialClick('facebook', 'follow_us_section')}
        >
          <FacebookIcon />
          Digging in the Sales Crates
        </a>
        {/* Amber styling is inline because index.css only defines the
            TikTok and Facebook pill colors. Move it to a
            .follow-pill--newsletter rule there if you prefer. */}
        <a
          href={NEWSLETTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="follow-pill follow-pill--newsletter"
          aria-label="Join the free DITSC weekly newsletter"
          onClick={() => trackNewsletterClick(CLICK_SOURCES.FOLLOW_US)}
          style={{ background: 'var(--amber)', color: '#0a0a0f', fontWeight: 600 }}
        >
          <Mail size={14} aria-hidden="true" />
          Free weekly newsletter
        </a>
      </div>
    </div>
  );
}

function TikTokIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 12 14"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9 0.5C9.2 2.5 10.5 3.5 12 3.7v2.1c-1.2-.1-2.3-.5-3.2-1.2v5.4c0 2.2-1.8 4-4 4S.8 12.2.8 10 2.6 6 4.8 6c.2 0 .4 0 .6.1V8.3c-.2-.1-.4-.1-.6-.1-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8V.5H9z"
        fill="currentColor"
      />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 12 14"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M7.5 7.5H9.5L10 5H7.5V3.5C7.5 2.9 7.8 2.5 8.5 2.5H10V0.3C9.6 0.2 8.9 0 7.9 0 5.9 0 4.5 1.3 4.5 3.3V5H2.5v2.5H4.5V14H7.5V7.5z"
        fill="currentColor"
      />
    </svg>
  );
}
